import Editor from './Editor';
import './App.css';

function App() {
  return (
    <div className="App">
     <Editor></Editor>
    </div>
  );
}

export default App;
